import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const MicrophoneOffIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M7.5 14.6667V12.6667C7.5 12.3905 7.72386 12.1667 8 12.1667C8.27614 12.1667 8.5 12.3905 8.5 12.6667V14.6667C8.5 14.9428 8.27614 15.1667 8 15.1667C7.72386 15.1667 7.5 14.9428 7.5 14.6667Z"
      fill="currentColor"
    />
    <path
      d="M6.94088 1.08075C7.44931 0.84302 8.02329 0.782934 8.56978 0.910825C9.1163 1.0388 9.60446 1.34708 9.95455 1.78583C10.3046 2.22465 10.4971 2.76939 10.5004 3.33075V6.22625C10.5004 6.42827 10.3784 6.61063 10.1919 6.68817C10.0052 6.76558 9.79 6.72341 9.64693 6.58075L5.85982 2.80047C5.70726 2.64803 5.67018 2.41505 5.76705 2.22235C6.01926 1.72092 6.43245 1.31853 6.94088 1.08075Z"
      fill="currentColor"
    />
    <path
      d="M2.83334 7.99969V6.66669C2.83334 6.39054 3.05719 6.16669 3.33334 6.16669C3.60948 6.16669 3.83334 6.39054 3.83334 6.66669V7.99969C3.83328 8.82383 4.07765 9.62986 4.53548 10.3151C4.99332 11.0004 5.64422 11.5349 6.4056 11.8503C7.1669 12.1656 8.00466 12.2474 8.81283 12.0866C9.62106 11.9258 10.3639 11.5297 10.9466 10.947C11.1418 10.7517 11.4584 10.7509 11.6536 10.946C11.8489 11.1412 11.8489 11.4587 11.6536 11.654C10.9311 12.3765 10.0103 12.8687 9.00814 13.0681C8.00592 13.2674 6.96688 13.1651 6.02279 12.7741C5.07878 12.3831 4.27213 11.7204 3.70443 10.8708C3.13671 10.0211 2.83326 9.02162 2.83334 7.99969Z"
      fill="currentColor"
    />
    <path
      d="M12.1666 7.99969V6.66669C12.1666 6.39058 12.3905 6.16674 12.6666 6.16669C12.9427 6.16669 13.1666 6.39054 13.1666 6.66669V8.00067C13.1663 8.30488 13.1392 8.60847 13.0855 8.9079C13.0368 9.17957 12.7771 9.36071 12.5054 9.31219C12.2338 9.26346 12.0526 9.00378 12.1011 8.73212C12.1337 8.55079 12.1544 8.36719 12.1627 8.18329L12.1666 7.99969Z"
      fill="currentColor"
    />
    <path
      d="M0.979821 0.979821C1.17508 0.784558 1.49159 0.784558 1.68685 0.979821L15.0199 14.3128C15.2151 14.5081 15.2151 14.8246 15.0199 15.0199C14.8246 15.2151 14.5081 15.2151 14.3128 15.0199L0.979821 1.68685C0.784558 1.49159 0.784558 1.17508 0.979821 0.979821Z"
      fill="currentColor"
    />
    <path
      d="M5.80859 5.53807C5.99543 5.46068 6.21052 5.50347 6.35352 5.64647L9.7666 9.05956C9.86031 9.15327 9.91302 9.28056 9.91309 9.41307C9.91304 9.54573 9.86047 9.67382 9.7666 9.76756C9.41707 10.1166 8.97177 10.3539 8.4873 10.4502C8.00269 10.5465 7.50045 10.4966 7.04395 10.3076C6.58749 10.1186 6.1966 9.79926 5.92188 9.38866C5.68157 9.0294 5.53906 8.61446 5.50684 8.18553L5.5 7.99999V5.99999C5.5 5.79778 5.62179 5.61548 5.80859 5.53807Z"
      fill="currentColor"
    />
  </svg>
);
